exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fFQBlci2XvOlKr{font-size:16px;margin-bottom:2em}._2QeU0IcCfybyle{resize:none;height:80px}", ""]);

// exports
exports.locals = {
	"question": "fFQBlci2XvOlKr",
	"freeform": "_2QeU0IcCfybyle"
};